
export default class PaymentUnsubscribableViewModel {
    constructor(data) {
        this.unsubscribeUrl = data.unsubscribeUrl;
        this.accessMethod = data.accessMethod;
        this.name = data.name;
    }
}